import { DateHelper, EnvironmentHelper, MessageInterface } from ".";

export class MessageHelper {

  static getThumbnailPath(message: MessageInterface) {
    if (!message || message.thumbnailPending) return "/images/updating-thumbnail.png";
    else {
      let lastModified = DateHelper.convertToDate(message.lastModified || new Date());
      lastModified = new Date(lastModified.toUTCString().replace(" GMT", ""));
      return EnvironmentHelper.ContentRoot + "/messages/" + message.id + "/thumb/" + DateHelper.formatDateTime(lastModified, "yyMMddHHmmss") + ".png";
    }

  }

}